import {
  eLanguageManagementComponents,
  LanguageManagementEntityPropContributors,
} from '@volo/abp.ng.language-management';
import { autoSizeEntityPropColumns } from 'src/app/shared/helpers/extensible-table-columns.helper';

export const LANGUAGE_MANAGEMENT_ENTITY_PROP_CONTRIBUTORS: LanguageManagementEntityPropContributors = {
  [eLanguageManagementComponents.Languages]: [autoSizeEntityPropColumns],
};
